module.exports = __webpack_public_path__ + "img/HZ-B5666.4d10727c.jpg";